import { Loader } from '@/components/shared';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { MyAccountLayout } from '../layout';

export const MyAccount: React.FC = (): JSX.Element => {
  return (
    <MyAccountLayout>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </MyAccountLayout>
  );
};
